import React from 'react'
import { NavLink } from 'react-router-dom'
import { C, fBody, fOutfit } from './Brand'

export const NAV_LINKS = [
  { to: '/user/bot', label: 'Arbitrade Bot', icon: 'ri-robot-2-line' },
  { to: '/user/subscriptions', label: 'Subscriptions', icon: 'ri-coupon-line' },
  { to: '/user/withdrawal', label: 'Withdrawal', icon: 'ri-download-2-fill' },
  { to: '/user/history', label: 'History', icon: 'ri-file-list-3-line' },
  { to: '/user/income', label: 'Income', icon: 'ri-pie-chart-line' },
  { to: '/user/allmember', label: 'All Members', icon: 'ri-group-line' },
  { to: '/user/directmember', label: 'Direct Members', icon: 'ri-user-add-line' },
  { to: '/user/support', label: 'Support', icon: 'ri-customer-service-2-line' },
]

export const dashboardStyles = `
.xdb { font-family: ${fBody}; min-height: 100vh; background: ${C.dark}; display: flex; flex-direction: column; }
.xdb-topbar {
  height: 64px; flex-shrink: 0; display: flex; align-items: center; justify-content: space-between;
  padding: 0 20px; border-bottom: 1px solid ${C.dbdr}; background: ${C.dark}; position: sticky; top: 0; z-index: 30;
}
.xdb-topnav {
  display: flex; align-items: center; gap: 4px; padding: 0 20px 10px; overflow-x: auto;
  border-bottom: 1px solid ${C.dbdr}; background: ${C.dark};
}
.xdb-nav-link {
  display: flex; align-items: center; gap: 8px; padding: 9px 14px; border-radius: 999px;
  color: ${C.ltx2}; font-size: 13px; font-weight: 500; text-decoration: none; white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}
.xdb-nav-link i { font-size: 15px; }
.xdb-nav-link:hover { background: rgba(255,255,255,0.04); color: ${C.ltx}; }
.xdb-nav-link.active { background: rgba(247,147,26,0.12); color: ${C.primary}; }
.xdb-content { padding: 20px; flex: 1; }
.xdb-card {
  background: ${C.card}; border: 1px solid ${C.dbdr}; border-radius: 14px; padding: 18px;
}
.xdb-stat-row { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 20px; }
.xdb-stat-card { flex: 1 1 200px; min-width: 160px; }
.xdb-stat-label { font-size: 12px; color: ${C.ltx3}; margin-bottom: 6px; }
.xdb-stat-value { font-size: 22px; font-weight: 700; color: ${C.ltx}; font-family: ${fOutfit}; }
.xdb-page-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 18px; flex-wrap: wrap; }
.xdb-page-title { font-size: 20px; font-weight: 700; color: ${C.ltx}; font-family: ${fOutfit}; margin: 0; }
.xdb-btn {
  background: ${C.primary}; color: ${C.dark}; border: none; border-radius: 999px; padding: 10px 18px;
  font-weight: 700; font-size: 13px; cursor: pointer; transition: background 0.15s;
}
.xdb-btn:hover { background: ${C.primaryDark}; }
.xdb-table-wrap { overflow-x: auto; border: 1px solid ${C.dbdr}; border-radius: 12px; }
.xdb-table { width: 100%; border-collapse: collapse; min-width: 100%; }
.xdb-table thead th {
  text-align: left; font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; color: ${C.ltx3};
  padding: 12px 16px; background: ${C.dark2}; white-space: nowrap;
}
.xdb-table tbody td { padding: 13px 16px; font-size: 13px; color: ${C.ltx2}; border-top: 1px solid ${C.dbdr}; white-space: nowrap; }
.xdb-table tbody tr:hover { background: rgba(255,255,255,0.02); }
.xdb-tabs { display: flex; gap: 8px; margin-bottom: 16px; flex-wrap: wrap; }
.xdb-tab {
  background: transparent; border: 1px solid ${C.dbdr}; color: ${C.ltx2}; border-radius: 999px;
  padding: 8px 16px; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.15s;
}
.xdb-tab.active { background: ${C.primary}; border-color: ${C.primary}; color: ${C.dark}; }
.xdb-pagination { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 14px 4px; flex-wrap: wrap; }
.xdb-pagination-info { font-size: 12px; color: ${C.ltx3}; }
.xdb-pagination-btns { display: flex; gap: 6px; }
.xdb-page-btn {
  background: ${C.card}; border: 1px solid ${C.dbdr}; color: ${C.ltx2}; border-radius: 8px; width: 32px; height: 32px;
  cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.15s;
}
.xdb-page-btn:hover:not(:disabled) { border-color: ${C.primary}; color: ${C.primary}; }
.xdb-page-btn:disabled { opacity: 0.35; cursor: not-allowed; }
.xdb-empty { padding: 32px 16px; text-align: center; color: ${C.ltx3}; font-size: 13px; }
.xdb-label { display: block; font-size: 12px; color: ${C.ltx2}; margin-bottom: 6px; font-weight: 500; }
.xdb-input {
  width: 100%; background: rgba(255,255,255,0.04); border: 1px solid ${C.dbdr}; color: ${C.ltx};
  border-radius: 10px; padding: 11px 14px; font-size: 14px; font-family: ${fBody}; transition: border-color 0.2s;
  box-sizing: border-box;
}
.xdb-input:focus { outline: none; border-color: ${C.primary}; }
.xdb-bot-top-grid { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 12px; margin-bottom: 12px; align-items: stretch; }
.xdb-bot-top-grid > .xdb-card { display: flex; flex-direction: column; }
.xdb-bot-top-grid > .xdb-card .xdb-table-wrap { flex: 1; overflow-y: auto; }
.xdb-bot-grid { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 12px; margin-bottom: 16px; align-items: start; }
@media (max-width: 900px) {
  .xdb-bot-top-grid { grid-template-columns: 1fr; }
  .xdb-bot-grid { grid-template-columns: 1fr; }
}
@media (max-width: 1100px) {
  .xdb-dashboard-grid { grid-template-columns: 1fr !important; }
}
@media (max-width: 640px) {
  .xdb-dashboard-subgrid { grid-template-columns: 1fr !important; }
}
@media (max-width: 900px) {
  .xdb-content { padding: 14px; }
  .xdb-stat-card { flex: 1 1 140px; }
  .xdb-topbar { padding: 0 14px; }
}
`

export function TopNav() {
  return (
    <nav className="xdb-topnav">
      {NAV_LINKS.map((link) => (
        <NavLink key={link.to} to={link.to} className={({ isActive }) => `xdb-nav-link${isActive ? ' active' : ''}`}>
          <span>{link.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}

export function PageHeader({ title, action }) {
  return (
    <div className="xdb-page-header">
      <h2 className="xdb-page-title">{title}</h2>
      {action}
    </div>
  )
}

export function StatRow({ children }) {
  return <div className="xdb-stat-row">{children}</div>
}

export function StatCard({ label, value, icon }) {
  return (
    <div className="xdb-card xdb-stat-card">
      <div className="xdb-stat-label">{label}</div>
      <div className="xdb-stat-value">{icon ? <i className={icon} style={{ marginRight: 8, color: C.primary }} /> : null}{value}</div>
    </div>
  )
}

export function TableWrap({ children }) {
  return (
    <div className="xdb-table-wrap">
      <table className="xdb-table">{children}</table>
    </div>
  )
}

export function TabBar({ tabs, active, onChange }) {
  return (
    <div className="xdb-tabs">
      {tabs.map((tab) => (
        <button key={tab.key} type="button" className={`xdb-tab${active === tab.key ? ' active' : ''}`} onClick={() => onChange(tab.key)}>
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export function Pagination({ page, totalPages, onFirst, onPrev, onNext, onLast, from, to, total }) {
  if (totalPages <= 1) return null
  return (
    <div className="xdb-pagination">
      <div className="xdb-pagination-info">Showing {from} to {to} of {total}</div>
      <div className="xdb-pagination-btns">
        <button className="xdb-page-btn" onClick={onFirst} disabled={page === 1}><i className="ri-skip-back-line" /></button>
        <button className="xdb-page-btn" onClick={onPrev} disabled={page === 1}><i className="ri-arrow-left-s-line" /></button>
        <button className="xdb-page-btn" onClick={onNext} disabled={page === totalPages}><i className="ri-arrow-right-s-line" /></button>
        <button className="xdb-page-btn" onClick={onLast} disabled={page === totalPages}><i className="ri-skip-forward-line" /></button>
      </div>
    </div>
  )
}

export function EmptyState({ message = 'No data available.' }) {
  return <div className="xdb-empty">{message}</div>
}
